<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick" />
    </div>
    <div class="d-right">
      <div style="margin-top: 5px">
        <el-button @click="search">查询</el-button>
      </div>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="项目">
          <el-input
            v-model="form.houseName"
            size="mini"
            placeholder="输入房产或项目名称搜索"
          />
        </el-descriptions-item>
        <el-descriptions-item label="收支时间">
          <el-date-picker
            v-model="startDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="endDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
        <el-descriptions-item label="类型">
          <el-radio v-model="form.type" label="">全部</el-radio>
          <el-radio v-model="form.type" label="1">收入</el-radio>
          <el-radio v-model="form.type" label="2">支出</el-radio>
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        max-height="750px"
        :data="listData"
        border
        style="margin-top: 8px"
        v-loading="loading"
      >
        <el-table-column prop="name" label="项目" />
        <el-table-column prop="create_at" label="操作时间" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="amount" label="金额" />
        <el-table-column label="操作">
          <template slot-scope="data">
            <el-link v-if="ERP.isPermission(4009002001)" :underline="false" @click="delAnenityFee(data.row.id)">
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
export default {
  name: "AmenityCharge",
  components: {
    ErpTree,
  },
  data() {
    return {
      form: {
        houseName: "",
        houseId: "",
        pid: "",
        pageSize: 10,
        page: 1,
        startDate: "",
        endDate: "",
        type: ""
      },
      url: "",
      dialogImportModel: false,
      importData: [],
      fileList: [],
      listData: [],
      totalCount: 0,
      startDate: "",
      endDate: "",
      loading: false,
    };
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
    "form.pageSize"(n) {
      this.search();
    },
  },
  mounted() {},
  methods: {
    nodeClick(data) {
      this.form.pid = data.tree[0].projectId;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
      if (data.type === "room") {
        this.form.houseId = data.id;
      } else {
        this.form.houseId = "";
      }
    },
    search() {
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.loading = true;
      this.$myhttp
        .post("admin/AmenityFee/amenityFeeIncome", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loading = false;
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    delAnenityFee(id) {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/AmenityFee/deleteCharge",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loading = false;
            this.$message.success(backdata.data.msg);
            this.search();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
  },
};
</script>

<style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 265px);
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/AmenityFee/charge.vue